import { setFuncionario } from '@/modules/configuracoes/funcionario/store/index';
import { setFilial } from '@/modules/configuracoes/filial/store/index';
import { setCaixa } from '@/modules/financeiro/financeiroCaixaMov/store/index';
import SessionService from './service';

function setSession(data) {
  setFuncionario(data.funcionario);
  setFilial(data.filial);
  setCaixa(data.financeiroCaixaMov);
}

export { setSession, SessionService };
